import React from 'react';
import { IconMail } from '@tabler/icons-react';

export interface HeaderProps {
    title?: string;
    subtitle?: string;
    userEmail?: string;
    showLogo?: boolean;
    actions?: React.ReactNode;
    navigation?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
    title = "SCVČ Tri Hôrky",
    subtitle,
    userEmail,
    showLogo = true,
    actions,
    navigation
}) => {
    return (
        <header className="bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
                <div className="flex justify-between items-center h-14 sm:h-16">
                    <div className="flex items-center min-w-0 flex-1">
                        {showLogo && (
                            <img src="/img/3h.png" alt="Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-3 flex-shrink-0" />
                        )}
                        <div className="min-w-0 flex-1">
                            <h1 className="text-base sm:text-xl font-bold text-gray-900 truncate">{title}</h1>
                            {subtitle && (
                                <p className="text-xs sm:text-sm text-gray-600 truncate">{subtitle}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
                        {userEmail && (
                            <div className="hidden sm:flex items-center space-x-2 text-sm text-gray-600">
                                <IconMail className="h-4 w-4" />
                                <span className="truncate max-w-32 lg:max-w-none">{userEmail}</span>
                            </div>
                        )}
                        {actions}
                    </div>
                </div>

                {navigation && (
                    <div className="border-t border-gray-200">
                        {navigation}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
